module.exports = __webpack_public_path__ + "static/media/arke_logo_dark.0782f003.png";